import { setContext } from '@apollo/client/link/context'
import parse from 'url-parse'
import { getLocaleByDomain } from '~/utils/localization'
import getConfig from 'next/config'
import { GetServerSidePropsContext } from 'next'
import { getUserId } from '~/lib/optimizely/getUserId'
import { getCookie } from 'cookies-next'

const { publicRuntimeConfig } = getConfig()

const { host } = parse(publicRuntimeConfig.NEXT_PUBLIC_API_URL)

const headersLink = (context?: GetServerSidePropsContext) => {
  return setContext((_graphQLRequest, prevContext) => {
    const cookieName = process.env.NEXT_PUBLIC_TOKEN_COOKIE_NAME as string
    const token = getCookie(cookieName, context)
    const localeFromHostname = context?.locale ?? getLocaleByDomain(window.location.hostname)
    const deviceId = getUserId(context)

    return {
      headers: {
        ...prevContext.headers,
        Authorization: token ? `Bearer ${token}` : '',
        ...(context?.req?.headers['user-agent'] && {
          'user-agent': context.req.headers['user-agent'],
        }),
        ...(context?.req?.headers['x-forwarded-for'] && {
          'x-forwarded-for': context.req.headers['x-forwarded-for'],
        }),
        ...(context?.req?.headers['x-forwarded-port'] && {
          'x-forwarded-port': context.req.headers['x-forwarded-port'],
        }),
        ...(context?.req?.headers['x-forwarded-proto'] && {
          'x-forwarded-proto': context.req.headers['x-forwarded-proto'],
        }),
        ...(context?.req?.headers['x-amzn-waf-anonymous-ip'] && {
          'x-amzn-waf-anonymous-ip': context.req.headers['x-amzn-waf-anonymous-ip'],
        }),
        ...(context?.req?.headers['x-amzn-waf-hosting-provider-ip'] && {
          'x-amzn-waf-hosting-provider-ip': context.req.headers['x-amzn-waf-hosting-provider-ip'],
        }),
        ...(localeFromHostname && {
          'accept-language': localeFromHostname,
        }),
        host,
        'device-id': deviceId,
      },
    }
  })
}

export default headersLink
